<template>
  <div ref="watermark" class="cont">
    <el-breadcrumb separator="/" style="margin-bottom:21px">
      <el-breadcrumb-item :to="{ path: '/' }" style="font-size: 12px;color: #999999 ">首页</el-breadcrumb-item>
      <el-breadcrumb-item style="font-size: 12px;color: #666666;">刹车油及其他产品</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="main-cont clear">
      <div style="margin-bottom:20px;display:flex;align-items:center">
        <div style="text-align:right;flex:1"  >
          <span style="margin-right:10px;font-size: 14px;color: #333333;">价格开关</span>
          <el-switch v-model="priceShow" @change="togglePriceShow"> </el-switch>
          <span style="margin-right:10px;margin-left:20px;font-size: 14px;color: #333333;">现货开关</span>
          <el-switch v-model="goodsShow" @change="toggle"> </el-switch>
        </div>

      </div>

      <el-container style="min-height: 500px; border: 1px solid #eee ; ">
        <el-aside width="133px" style="background-color: rgb(238, 241, 246);">
          <el-menu class="el-menu-vertical-demo" >
            <el-menu-item
                    :index='idx.toString()'
                    v-for=" (navItem , idx ) in category " :key='idx'
                    @click="switchNav(idx)"
                    style="cursor : pointer; padding-left: 10px;text-align: center;"  >
              <span slot="title" style="font-weight:700;">{{ navItem.name }}</span>
            </el-menu-item>
          </el-menu>
        </el-aside>

        <el-container style="position:relative" v-if='currentTab == 0'>
        <div class="brakeFluidsItem1" v-show="brakeFluidsItem1Vis">
          <div class="line"  v-for=" ( calipersItem , idx ) in brakeFluids1 " :key='idx'  @click.stop="panel1(idx)"
               style="cursor : pointer" v-bind:class="{ 'active': calipersItem.id == brakeFluidsItem1Id  }" >
            {{ calipersItem.name }}
          </div>
        </div>
        <div class="brakeFluidsItem2" v-show="brakeFluidsItem2Vis"   v-if='brakeFluids1Children.length > 0'>
          <div class="line"
               v-for=" ( itemchild , idxchild ) in brakeFluids1Children " :key='"child"+idxchild'
               @click="gotoList( itemchild.id , itemchild.ptype ,itemchild,1 )"
               style="cursor : pointer" >
            {{ itemchild.name }}
          </div>
        </div>
        <div class="brakeFluidsItem2" v-show="brakeFluidsItem2Vis"   v-else-if='brakeFluids1Children.length == 0'>
          <div class="line">
            暂无内容
          </div>
        </div>

        <div class="clear" style="width: 100%;padding: 10px;color: #7F7F7F;font-size: 14px" v-if='goods.length > 0'>
          <div style="margin-bottom:10px;display:flex;align-items:center">
            {{ name1 }}{{ name2 }}
          </div>

          <div class="item" v-for=" ( goodItem , idx ) in goods " :key='idx' @click="gotoDetail(goodItem)" style="cursor : pointer">
            <div class="num_cont">
              <el-image
                v-if="goodItem.amount == 0"
                style="width: 50px; height: 50px"
                :src="u189"
                fit="contain">
              </el-image>
              <el-image
                v-if="goodItem.amount <= moduleUser.goods_num && goodItem.amount > 0"
                style="width: 50px; height: 50px"
                :src=" publicUrl + '/profile/avatar/u188.png' "
                fit="contain">
              </el-image>
              <el-image
                v-if="goodItem.amount > moduleUser.goods_num"
                style="width: 50px; height: 50px"
                :src=" publicUrl + '/profile/avatar/u187.png' "
                fit="contain">
              </el-image>
            </div>
            <div>
              <el-image
                style="width: 200px; height: 200px;margin-top:16px;margin-bottom:10px"
                class="product_image"
                :src=' publicUrl + goodItem.apiGoodsSpec.goodsPic '
                fit="contain"
              ></el-image>
              </div>
              <div class="line line1" style="min-height: 30px">
                <el-image v-if="goodItem.promotionStatus ==1"
                          style="width: 100px; height: 25px" :src=" publicUrl + '/profile/avatar/cxz.png' " fit="contain">
                </el-image>
              </div>
              <div class="line line1" v-if="moduleUser.goods_visible == '1' ">{{ goodItem.goodsName }}
                <span v-if="goodItem.apiGoodsSpec.salesUnit" style="color: red">({{goodItem.apiGoodsSpec.salesUnit}})</span>
              </div>
              <div class="line line1" v-else-if="moduleUser.goods_visible == '0' ">{{ goodItem.goodsErp.specification }}</div>

              <div class="line line2" style="min-height: 64px" >
                <span  class="ql-editor" v-html="goodItem.description ? goodItem.description : ''"></span>
              </div>
              <div class='line line2'  @click.stop="goodsStockDetail(goodItem)" style="color: red">查看库存详情>></div>
              <div class='line line3'>
                <div style="color: #7F7F7F;">
                  <div>零售价</div>
                  <div> ¥ {{ goodItem.apiGoodsSpec.goodsPrice }}</div>
                </div>
                <div style="color: #E60012;" v-show="priceShow&&goodItem.promotionStatus ==1">
                  <div style="text-decoration: line-through;">拿货价</div>
                  <div style="text-decoration: line-through;"> ¥ {{goodItem.apiGoodsSpec.discountPrice }}</div>
                </div>
                <div style="color: #E60012;" v-show="priceShow&&goodItem.promotionStatus ==1">
                  <div>活动价</div>
                  <div> ¥ {{goodItem.promotionPrice }}</div>
                </div>
                <div style="color: #E60012;" v-show="priceShow&&goodItem.promotionStatus !=1">
                  <div>拿货价</div>
                  <div> ¥ {{goodItem.apiGoodsSpec.discountPrice }}</div>
                </div>
              </div>
              <div style="display:flex">
                <div class="background_style btn"
                  :style="{backgroundImage: 'url(' + btn_red + ')' }"
                  @click.stop="gotoSettlement(goodItem)"
                  style="cursor : pointer"
                >
                  立即购买
                </div>
                <div class="background_style btn"
                  :style="{backgroundImage: 'url(' + btn_black + ')' }"
                  @click.stop="addCartItem(goodItem)"
                  style="cursor : pointer"
                >
                  加入购物车
                </div>
              </div>
            </div>
          </div>

          <div style="color:gray;padding:30px;text-align:center;width:100%" v-else>
            请选择刹车油及其他产品
          </div>

        </el-container>

        <el-container style="position:relative" v-if='currentTab == 1'>
          <div class="brakeFluidsItem1" v-show="brakeFluidsItem1Vis">
            <div class="line"  v-for=" ( calipersItem , idx ) in brakeFluids2 " :key='idx'  @click.stop="panel2(idx)"
                 style="cursor : pointer" v-bind:class="{ 'active': calipersItem.id == brakeFluidsItem1Id  }" >
              {{ calipersItem.name }}
            </div>
          </div>
          <div class="brakeFluidsItem2" v-show="brakeFluidsItem2Vis"   v-if='brakeFluids2Children.length > 0'>
            <div class="line"
                 v-for=" ( itemchild , idxchild ) in brakeFluids2Children " :key='"child"+idxchild'
                 @click="gotoList( itemchild.id , itemchild.ptype ,itemchild,1 )"
                 style="cursor : pointer" >
              {{ itemchild.name }}
            </div>
          </div>
          <div class="brakeFluidsItem2" v-show="brakeFluidsItem2Vis"   v-else-if='brakeFluids2Children.length == 0'>
            <div class="line">
              暂无内容
            </div>
          </div>

          <div class="clear" style="width: 100%;padding: 10px;color: #7F7F7F;font-size: 14px" v-if='goods.length > 0'>
            <div style="margin-bottom:10px;display:flex;align-items:center">
              {{ name1 }}{{ name2 }}
            </div>

            <div class="item" v-for=" ( goodItem , idx ) in goods " :key='idx' @click="gotoDetail(goodItem)" style="cursor : pointer">
              <div class="num_cont">
                <el-image
                        v-if="goodItem.amount == 0"
                        style="width: 50px; height: 50px"
                        :src="u189"
                        fit="contain">
                </el-image>
                <el-image
                        v-if="goodItem.amount <= moduleUser.goods_num && goodItem.amount > 0"
                        style="width: 50px; height: 50px"
                        :src=" publicUrl + '/profile/avatar/u188.png' "
                        fit="contain">
                </el-image>
                <el-image
                        v-if="goodItem.amount > moduleUser.goods_num"
                        style="width: 50px; height: 50px"
                        :src=" publicUrl + '/profile/avatar/u187.png' "
                        fit="contain">
                </el-image>
              </div>
              <div>
                <el-image
                        style="width: 200px; height: 200px;margin-top:16px;margin-bottom:10px"
                        class="product_image"
                        :src=' publicUrl + goodItem.apiGoodsSpec.goodsPic '
                        fit="contain"
                ></el-image>
              </div>
              <div class="line line1" style="min-height: 30px">
                <el-image v-if="goodItem.promotionStatus ==1"
                          style="width: 100px; height: 25px" :src=" publicUrl + '/profile/avatar/cxz.png' " fit="contain">
                </el-image>
              </div>
              <div class="line line1" v-if="moduleUser.goods_visible == '1' ">{{ goodItem.goodsName }}
                <span v-if="goodItem.apiGoodsSpec.salesUnit" style="color: red">({{goodItem.apiGoodsSpec.salesUnit}})</span>
              </div>
              <div class="line line1" v-else-if="moduleUser.goods_visible == '0' ">{{ goodItem.goodsErp.specification }}</div>

              <div class="line line2" style="min-height: 64px" >
                <span  class="ql-editor" v-html="goodItem.description ? goodItem.description : ''"></span>
              </div>
              <div class='line line2'  @click.stop="goodsStockDetail(goodItem)" style="color: red">查看库存详情>></div>
              <div class='line line3'>
                <div style="color: #7F7F7F;">
                  <div>零售价</div>
                  <div> ¥ {{ goodItem.apiGoodsSpec.goodsPrice }}</div>
                </div>
                <div style="color: #E60012;" v-show="priceShow&&goodItem.promotionStatus ==1">
                  <div style="text-decoration: line-through;">拿货价</div>
                  <div style="text-decoration: line-through;"> ¥ {{goodItem.apiGoodsSpec.discountPrice }}</div>
                </div>
                <div style="color: #E60012;" v-show="priceShow&&goodItem.promotionStatus ==1">
                  <div>活动价</div>
                  <div> ¥ {{goodItem.promotionPrice }}</div>
                </div>
                <div style="color: #E60012;" v-show="priceShow&&goodItem.promotionStatus !=1">
                  <div>拿货价</div>
                  <div> ¥ {{goodItem.apiGoodsSpec.discountPrice }}</div>
                </div>
              </div>
              <div style="display:flex">
                <div class="background_style btn"
                     :style="{backgroundImage: 'url(' + btn_red + ')' }"
                     @click.stop="gotoSettlement(goodItem)"
                     style="cursor : pointer"
                >
                  立即购买
                </div>
                <div class="background_style btn"
                     :style="{backgroundImage: 'url(' + btn_black + ')' }"
                     @click.stop="addCartItem(goodItem)"
                     style="cursor : pointer"
                >
                  加入购物车
                </div>
              </div>
            </div>
          </div>

          <div style="color:gray;padding:30px;text-align:center;width:100%" v-else>
            请选择刹车油及其他产品
          </div>

        </el-container>

        <el-container style="position:relative" v-if='currentTab == 2'>
          <div class="brakeFluidsItem1" v-show="brakeFluidsItem1Vis">
            <div class="line"  v-for=" ( calipersItem , idx ) in brakeFluids9 " :key='idx'  @click.stop="panel3(idx)"
                 style="cursor : pointer" v-bind:class="{ 'active': calipersItem.id == brakeFluidsItem1Id  }" >
              {{ calipersItem.name }}
            </div>
          </div>
          <div class="brakeFluidsItem2" v-show="brakeFluidsItem2Vis"   v-if='brakeFluids9Children.length > 0'>
            <div class="line"
                 v-for=" ( itemchild , idxchild ) in brakeFluids9Children " :key='"child"+idxchild'
                 @click="gotoList( itemchild.id , itemchild.ptype ,itemchild,1 )"
                 style="cursor : pointer" >
              {{ itemchild.name }}
            </div>
          </div>
          <div class="brakeFluidsItem2" v-show="brakeFluidsItem2Vis"   v-else-if='brakeFluids9Children.length == 0'>
            <div class="line">
              暂无内容
            </div>
          </div>

          <div class="clear" style="width: 100%;padding: 10px;color: #7F7F7F;font-size: 14px" v-if='goods.length > 0'>
            <div style="margin-bottom:10px;display:flex;align-items:center">
              {{ name1 }}{{ name2 }}
            </div>

            <div class="item" v-for=" ( goodItem , idx ) in goods " :key='idx' @click="gotoDetail(goodItem)" style="cursor : pointer">
              <div class="num_cont">
                <el-image
                        v-if="goodItem.amount == 0"
                        style="width: 50px; height: 50px"
                        :src="u189"
                        fit="contain">
                </el-image>
                <el-image
                        v-if="goodItem.amount <= moduleUser.goods_num && goodItem.amount > 0"
                        style="width: 50px; height: 50px"
                        :src=" publicUrl + '/profile/avatar/u188.png' "
                        fit="contain">
                </el-image>
                <el-image
                        v-if="goodItem.amount > moduleUser.goods_num"
                        style="width: 50px; height: 50px"
                        :src=" publicUrl + '/profile/avatar/u187.png' "
                        fit="contain">
                </el-image>
              </div>
              <div>
                <el-image
                        style="width: 200px; height: 200px;margin-top:16px;margin-bottom:10px"
                        class="product_image"
                        :src=' publicUrl + goodItem.apiGoodsSpec.goodsPic '
                        fit="contain"
                ></el-image>
              </div>
              <div class="line line1" style="min-height: 30px">
                <el-image v-if="goodItem.promotionStatus ==1"
                          style="width: 100px; height: 25px" :src=" publicUrl + '/profile/avatar/cxz.png' " fit="contain">
                </el-image>
              </div>
              <div class="line line1" v-if="moduleUser.goods_visible == '1' ">{{ goodItem.goodsName }}
                <span v-if="goodItem.apiGoodsSpec.salesUnit" style="color: red">({{goodItem.apiGoodsSpec.salesUnit}})</span>
              </div>
              <div class="line line1" v-else-if="moduleUser.goods_visible == '0' ">{{ goodItem.goodsErp.specification }}</div>

              <div class="line line2" style="min-height: 64px">
                <span  class="ql-editor" v-html="goodItem.description ? goodItem.description : ''"></span>
              </div>
              <div class='line line2'  @click.stop="goodsStockDetail(goodItem)" style="color: red">查看库存详情>></div>
              <div class='line line3'>
                <div style="color: #7F7F7F;">
                  <div>零售价</div>
                  <div> ¥ {{ goodItem.apiGoodsSpec.goodsPrice }}</div>
                </div>
                <div style="color: #E60012;" v-show="priceShow&&goodItem.promotionStatus ==1">
                  <div style="text-decoration: line-through;">拿货价</div>
                  <div style="text-decoration: line-through;"> ¥ {{goodItem.apiGoodsSpec.discountPrice }}</div>
                </div>
                <div style="color: #E60012;" v-show="priceShow&&goodItem.promotionStatus ==1">
                  <div>活动价</div>
                  <div> ¥ {{goodItem.promotionPrice }}</div>
                </div>
                <div style="color: #E60012;" v-show="priceShow&&goodItem.promotionStatus !=1">
                  <div>拿货价</div>
                  <div> ¥ {{goodItem.apiGoodsSpec.discountPrice }}</div>
                </div>
              </div>
              <div style="display:flex">
                <div class="background_style btn"
                     :style="{backgroundImage: 'url(' + btn_red + ')' }"
                     @click.stop="gotoSettlement(goodItem)"
                     style="cursor : pointer"
                >
                  立即购买
                </div>
                <div class="background_style btn"
                     :style="{backgroundImage: 'url(' + btn_black + ')' }"
                     @click.stop="addCartItem(goodItem)"
                     style="cursor : pointer"
                >
                  加入购物车
                </div>
              </div>
            </div>
          </div>

          <div style="color:gray;padding:30px;text-align:center;width:100%" v-else>
            请选择刹车油及其他产品
          </div>

        </el-container>

      </el-container>




    <div style="text-align:center;background-color:#fff;padding:44px 0 38px" class='pagination'>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size ='pageSize'
        @current-change="handleCurrentChange"
        :current-page.sync="pageNum"
        prev-text=' 上一页 '
        next-text=' 下一页 '>
      </el-pagination>
    </div>

    </div>

    <el-dialog title="" :visible.sync="showFlag" width="650px" center  :show-close='false'
               :close-on-press-escape='false' :close-on-click-modal ='false' >
      <div style="width:100%;margin-bottom:10px;text-align: center">
        <div style="text-align: center;font-size: 20px;font-weight: bold;margin-bottom: 60px">{{goodsName}}</div>
        <div style="margin-bottom: 100px">
          <div v-for=" ( detail , idx ) in stockDetail " :key='idx' style="text-align: center;  width: 100%;   margin-left: 33%;margin-bottom: 20px">
            <div  class="background_style btn"  :style="{backgroundImage: 'url(' + u35 + ')' }" style="text-align: center;width: 200px" >
              <div v-if='detail.showFlag == "0"'>
                {{detail.subWarehouseName}} :
                <span  v-if='detail.quantity > moduleUser.goods_num'>现货充足</span>
                <span  v-else-if='detail.quantity <= moduleUser.goods_num && detail.quantity > 0' >少量现货</span>
                <span v-else-if= 'detail.quantity == 0'  >可以预定</span>
              </div>
              <div v-else-if='detail.showFlag == "1"'>
                {{detail.subWarehouseName}} :
                <span  v-if='detail.quantity > moduleUser.goods_num'>现货充足</span>
                <span  v-else>{{  detail.quantity }}</span>
              </div>
            </div>
          </div>
          <div   style="text-align: center;  width: 100%;   margin-left: 33%;margin-bottom: 20px">
            <div   class="background_style btn"  :style="{backgroundImage: 'url(' + u35 + ')' }" style="text-align: center;width: 200px" >
              在途数 :{{transitQuantity}}
            </div>
          </div>
        </div>
      </div>
      <div style="display:flex;justify-content:center">
        <div class="background_style btn"  :style="{backgroundImage: 'url(' + btn_red + ')' }"
             style="cursor : pointer"  @click="stockDetailCancel" >
          关闭
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { getGoodsListByBrakeFluidAndOther ,getCategoryBrakeFluidReq , addCartItemReq,getStockDetail } from "@/api/productList/productList";
import watermark from '@/utils/waterMark'

export default {
  comments:watermark,
  data(){
    return{
      showFlag : false ,
      stockDetail:[],
      goodsName:'',
      transitQuantity:0,
      publicUrl : this.common.publicUrl ,
      btn_red : this.common.publicUrl + '/profile/avatar/u146.png' ,
      u35 : this.common.publicUrl + '/profile/avatar/u35.png' ,
      btn_black : this.common.publicUrl + '/profile/avatar/u147.png' ,
      imgu105 :  this.common.publicUrl + '/profile/avatar/u105.png' ,
      imgu106 :  this.common.publicUrl + '/profile/avatar/u106.png' ,
      u189 :  this.common.publicUrl + ( this.$store.state.moduleUser.discount_status=='Y'?'/profile/avatar/u189.png':'/profile/avatar/u190.png') ,
      pageNum : 1 , //当前页数
      goods : [] , //商品列表
      pageSize : 20 , //每页条数
      query : '' , //查询参数
      total : 0 ,
      priceShow : true,
      goodsShow : false,
      name1 : '' ,//显示名称
      name2 : '' ,//显示名称
      brakeFluidsItem1Vis : false ,
      brakeFluidsItem2Vis : false ,
      visible : false ,
      category : [] ,
      brakeFluids1 : [] ,
      brakeFluids1Children : [] ,
      brakeFluids2 : [] ,
      brakeFluids2Children : [] ,
      brakeFluids9 : [] ,
      brakeFluids9Children : [] ,
      currentTab : 0 ,
      brakeFluidsItem1Id : ''  ,
      toggleQuery:undefined,
      toggleCategoryId:undefined,
      toggleItemChild:undefined
    }
  } ,

  computed : {
    moduleUser() {
      return this.$store.state.moduleUser; // 这里返回的是：{name: 'wang', age: 22}
    }
  },
  mounted(){
    this.$nextTick(()=>{
      let  dealerName =window.localStorage.dealerName
      let  username =window.localStorage.username
      let text =dealerName+username.substring(username.length-4,username.length)
      watermark.set(text,this.$refs.watermark);
    })
  },
  created(){

    this.goods = []
    this.pageNum = 1
    //this.search(1)
    this.getCategoryBrakeFluid()
    console.log("created")
    this.$nextTick(()=>{
      console.log(window.localStorage.priceShow==0?true:false)
      this.priceShow = window.localStorage.priceShow==0?true:false;
    })
  },

  methods : {
    toggle(){
       this.pageNum = 1;
      this.gotoList(this.toggleQuery,this.toggleCategoryId,this.toggleItemChild,0);
    },
    togglePriceShow(){
      window.localStorage["priceShow"] =this.priceShow?"0":"1";
    },
    getCategoryBrakeFluid(){
      getCategoryBrakeFluidReq().then( res => {
        if (res.data.status == 0) {
          this.category = res.data.category
          this.brakeFluids1 = res.data.brakeFluids1
          this.brakeFluids2 = res.data.brakeFluids2
          this.brakeFluids9 = res.data.brakeFluids9
        }else{
          this.$message.error(res.data.statusDesc);
        }
      })
    } ,
    handleCurrentChange(){
      // console.log( this.pageNum )
      this.search(0)
    } ,

    //切换菜单
    switchNav(idx){
      this.currentTab =  idx
      this.brakeFluidsItem1Vis = true
      this.brakeFluidsItem2Vis = false
      if( !this.visible ){
        this.togglePanel()
      }
    } ,
    // 点击空白区域关闭某个div图层
    togglePanel () {
      this.visible ? this.hide() : this.show()
      this.brakeFluidsItem1Id = ''
    },

    // 点击空白处关闭
    show () {
      this.visible = true
      document.addEventListener('click', this.hidePanel, false)
    },
    hide () {
      this.visible = false
      this.brakeFluidsItem1Vis = false ;
      this.brakeFluidsItem2Vis = false ;
      document.removeEventListener('click', this.hidePanel, false)
    },
    hidePanel (e) {
      if (this.$refs.searchMain!=null&& !this.$refs.searchMain.contains(e.target)  ) {
        this.hide()
      }
    } ,
    //点击面板1
    panel1(idx){
      // console.log( this.brakeFluids1[idx].children )
      // this.brakeFluidsItem2Vis = true
      // this.brakeFluidsItem1Id = this.brakeFluids1[idx].id
      //
      // if( this.brakeFluids1[idx].children.length > 0 ){
      //   this.brakeFluids1Children = this.brakeFluids1[idx].children
      // }else{
      //   this.brakeFluids1Children = []
      // }
      this.name1 = this.brakeFluids1[idx].name;
      this.gotoBrakeFluid(this.name1  , this.brakeFluids1[idx].id ,1)
      // console.log( this.brakeFluids1[idx] )
    } ,
    //点击面板2
    panel2(idx){
      // this.brakeFluidsItem2Vis = true
      // this.brakeFluidsItem1Id = this.brakeFluids2[idx].id
      //
      // if( this.brakeFluids2[idx].children.length > 0 ){
      //   this.brakeFluids2Children = this.brakeFluids2[idx].children
      // }else{
      //   this.brakeFluids2Children = []
      // }
      this.name1 = this.brakeFluids2[idx].name;
      this.gotoBrakeFluid(this.name1  , this.brakeFluids2[idx].id ,1)
    } ,

    //点击面板3
    panel3(idx){
      // this.brakeFluidsItem2Vis = true
      // this.brakeFluidsItem1Id = this.brakeFluids9[idx].id
      //
      // if( this.brakeFluids9[idx].children.length > 0 ){
      //   this.brakeFluids9Children = this.brakeFluids9[idx].children
      // }else{
      //   this.brakeFluids9Children = []
      // }
      this.name1 = this.brakeFluids9[idx].name;
      this.gotoBrakeFluid(this.name1  , this.brakeFluids9[idx].id ,1)
    } ,


    gotoBrakeFluid(query  , categoryId ,searchTypeEvent){

      this.toggleQuery = query;
      this.toggleCategoryId = categoryId;

      getGoodsListByBrakeFluidAndOther({
        pageNum : this.pageNum ,
        pageSize : this.pageSize ,
        queryName : query,
        query : categoryId ,
        categoryId : categoryId,
        goodsNumFlag : this.goodsShow   ,
        searchTypeEvent:searchTypeEvent
      }).then( res => {
        if (res.data.status == 0) {
          this.goods = res.data.goods ;
          this.total = res.data.total
          this.brakeFluidsItem1Vis = false ;
          this.brakeFluidsItem2Vis = false ;
          this.brakeFluidsItem1Id = ''
        } else {
          this.$message.error(res.data.statusDesc);
        }
      })
    } ,


    gotoList(query  , categoryId ,itemchild,searchTypeEvent){

      console.log(itemchild)
      this.toggleQuery = query;
      this.toggleCategoryId = categoryId;
      this.toggleItemChild = itemchild;



      // let that = this
      getGoodsListByBrakeFluidAndOther({
        pageNum : this.pageNum ,
        pageSize : this.pageSize ,
        queryName : query,
        query : categoryId ,
        categoryId : categoryId,
        goodsNumFlag : this.goodsShow   ,
        searchTypeEvent:searchTypeEvent
      }).then( res => {
        if (res.data.status == 0) {
          this.goods = res.data.goods ;
          this.total = res.data.total
          this.brakeFluidsItem1Vis = false ;
          this.brakeFluidsItem2Vis = false ;
          this.brakeFluidsItem1Id = ''
        } else {
          this.$message.error(res.data.statusDesc);
        }
      })
    } ,
    //点击跳转详情页
    gotoDetail( goodItem ){
      let goodsId = goodItem.goodsId
      let jancode = goodItem.apiGoodsSpec.jancode
      this.$router.push({
        path: '/goodDetail',
        query: {
          goodsId: goodsId ,
          jancode : jancode,
          searchType : 5,
          searchValue : this.name1,
        }
      })
    } ,
    //加入购物车
    addCartItem( goodItem ){
      let curGoodsInfo = goodItem
      addCartItemReq({
        goodsId : curGoodsInfo.goodsId ,
        goodsName : curGoodsInfo.goodsName ,
        jancode : curGoodsInfo.apiGoodsSpec.jancode ,
        goodsSpecId : curGoodsInfo.apiGoodsSpec.goodsSpecId ,
        quantity : 1 ,
        goodsPic : curGoodsInfo.apiGoodsSpec.goodsPic ,
        subTitle : curGoodsInfo.subTitle? curGoodsInfo.subTitle : '' ,
        specSkuId : curGoodsInfo.apiGoodsSpec.specSkuId ,
        sukSpec  : curGoodsInfo.apiGoodsSpec.sukSpec ,
        searchValue : this.name1 ,
        searchType : 5 ,
        description : curGoodsInfo.description
      }).then( res => {
        if (res.data.status == 0) {
          this.$message({
            message: '添加成功',
            type: 'success'
          });
          this.$store.commit('cart_refresh_open');
        } else {
          this.$message.error(res.data.statusDesc);
        }
      })
    },
    // 去结算页面
    gotoSettlement( goodItem ){
      let item = goodItem
      let apiTempOrder = []
      apiTempOrder.push({
        goodsId : item.goodsId ,
        jancode : item.apiGoodsSpec.jancode ,
        searchValue :  this.name1  ,
        quantity : 1 ,
      })
      if( apiTempOrder.length <= 0 ){
        this.$message('暂时不能购买');
        return
      }
      this.$store.commit('cart_refresh_open');
      apiTempOrder =  JSON.stringify( apiTempOrder )
      this.$router.push({
        path: '/splitOrder',
        query: {
          apiTempOrder : apiTempOrder ,
          isCartItem : 0 ,
        }
      })

    }, // 库存详情
    goodsStockDetail( goodItem ){
      let item = goodItem
      this.goodsName =item.goodsName
      this.stockDetail= [];
      getStockDetail({
        jancode:item.apiGoodsSpec.jancode ,
      }).then( res => {
        if (res.data.status == 0) {
          this.showFlag = true;
          this.stockDetail = res.data.stockDetail;
          this.transitQuantity = res.data.transitQuantity;
        } else {
          this.$message.error(res.data.statusDesc);

        }
      })

    }
    ,stockDetailCancel(){
      this.showFlag = false;
    }

  }
}
</script>

<style lang="stylus" scoped>
  .cont {
    width: 1200px;
    color: #000;
    margin: 0 auto;
    box-sizing: border-box;
    padding : 20px 0
  }


  .el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 60px;
  }

  .el-aside {
    color: #333;
    overflow-x : hidden
  }

  .main-cont {
    background-color: #fff;
    padding-top: 10px;
    padding-right: 25px;
    padding-bottom: 25px;
    padding-left: 25px;
    width:100%
  }
  .brakeFluidsItem1
    position:absolute;
    left: 0;
    top:0;
    width:281px;
    z-index:1000;
    background-color:#fafafa;
    box-shadow: rgba(0, 0, 0, 0.35) 5px 5px 5px 0px;
    border-right: 1px solid  #969696
    box-sizing border-box
    max-height 500px
    overflow-y : auto
    .line
      height: 47px;
      line-height 47px;
      font-size: 14px;
      font-weight: 700;
      color: #323233;
      text-indent 15px
      border-left : 4px solid #fff
    .line:hover
      background-color #ffe5e5
    .line.active
      border-left : 4px solid #f90000
  .brakeFluidsItem2
    position:absolute;
    left: 282px;
    top:0;
    width:281px;
    z-index:1000;
    background-color:#fafafa;
    box-shadow: rgba(0, 0, 0, 0.35) 5px 5px 5px 0px;
    max-height 500px
    overflow-y : auto
    .line
      max-height: 47px;
      line-height 47px;
      font-size: 13px;
      color: rgba(0, 0, 0, 0.4);
      padding-left 15px
      box-sizing: border-box
      overflow:hidden; //超出的文本隐藏
      text-overflow:ellipsis; //溢出用省略号显示
      white-space:nowrap; //溢出不换行
    .line:hover
      background-color #ffe5e5

  .main-cont >>> .el-menu-item.is-active {
    border-left : 4px solid #f90000
  }
  .main-cont >>> .el-menu-item {
    border-left : 4px solid #fff
  }

  .item {
    width: 230px;
    height: 480px;
    float: left;
    text-align: center;
    margin-right 50px
    margin-bottom 20px
    border: 1px solid rgb(242, 242, 242);
    box-sizing border-box
    position:relative
  }
  .num_cont{
    position absolute;
    right:0;
    top:0;
    height:50px;
    width:50px;
    z-index: 999
  }
  .line{
    overflow:hidden; //超出的文本隐藏
    text-overflow:ellipsis; //溢出用省略号显示
    white-space:nowrap; //溢出不换行
    padding : 0 10px ;
    box-sizing border-box
  }
  .line1{
    font-size: 12px;
    color: #333333;
    margin-bottom 7px
  }
  .line2{
    font-size: 12px;
    margin-bottom 12px;
    white-space: pre-wrap;
  }
  .line3{
    font-size: 14px;
    font-weight: 400;
    color: #F04844;
    margin-bottom 19px
    display : flex
    justify-content: space-around
  }
  .item:nth-child(3n + 4) {
    margin-right 0
  }

</style>

